import { useListContext } from "@/modules/list";

import { useParamsPreview } from "../list-params-preview.hook";

export const useListParamsPreviewButton = () => {
  const { filters, visibleSort } = useListContext();
  const { togglePreview } = useParamsPreview();

  const filtersCount = Object.keys(filters).length;
  const count = filtersCount + visibleSort.length;

  return {
    count,
    hasParams: count > 0,
    togglePreview,
  };
};
